
/// <amd-module name="Search/Shared/Components/NotificationArea/NotificationArea.Props" />
import { ObservableValue } from "VSS/Core/Observable";
import { MessageBarSeverity } from "VSSUI/MessageBar";

export interface INotificationProps {
    visible: boolean;

    severity: MessageBarSeverity;

    isFormatted: boolean;

    message: string;

    link?: string;

    linkLabel?: string;

    onLinkClick?(): void;

    onDismiss?(): void;
}

export interface INotificationAreaProps {
    notification: ObservableValue<INotificationProps>;
}
